module.exports = __webpack_public_path__ + "media/images/logo2-8cdd42eb776c4750a2375dfb81deb6fc.png";